import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { settingsRoute } from "./settings.route";

@NgModule({
  imports: [RouterModule.forChild(settingsRoute)],
  exports: [RouterModule],
})
export class SettingsRoutingModule {}
